module.exports = "/images/big-logo.svg";